function errorMessage(msg = 'Something went wrong...', styles = '') {
    M?.toast({
        html: `<div style="${styles}">${msg}</div>`,
        classes: 'err'
    });
}

function successMessage(msg = 'SUCCESS', styles = '') {
    M?.toast({
        html: `<div style="${styles}">${msg}</div>`,
        classes: 'info'
    });
}

export {errorMessage, successMessage};
